import { usePaginatedEvents } from "./usePaginatedEvents";
import { getActivityPeriodRange } from "../utils/activitySectionLinks";
import { DateUtil } from "../utils/DateUtil";

type Filters = {
    categories: string;
    free: string;
    period: string;
    time: string;
    searchQuery: string;
    city: string;
    venue: string;
    latitude?: string;
    longitude?: string;
};

const buildQueryParams = (filters: Filters): URLSearchParams => {

    let startDate = "";
    let endDate = "";

    const activityRange = getActivityPeriodRange(filters.period);
    if (activityRange) {
        startDate = activityRange.start;
        endDate = activityRange.end;
    }
    else if (filters.period == "nextWeek") {
        const weekDays = DateUtil.getWeekDays(true);
        startDate = weekDays.monday;
        endDate = weekDays.sunday;
    }
    else if (parseInt(filters.period) >= 0 && parseInt(filters.period) < 12) {
        const monthDays = DateUtil.getFirstAndLastDayOfMonth(parseInt(filters.period));
        startDate = monthDays.firstDay;
        endDate = monthDays.lastDay;
    }
    else if (DateUtil.isValidDateString(filters.period)) {
        startDate = filters.period;
    }

    const p = new URLSearchParams();
    p.set("category", filters.categories);
    p.set("timezone", "America/Toronto");
    p.set("date", startDate);
    if (filters.searchQuery) { p.set("searchQuery", filters.searchQuery); }
    if (filters.city) { p.set("city", filters.city); }
    if (endDate) { p.set("endDate", endDate); }
    if (filters.time) { p.set("time", filters.time); }
    if (filters.venue) { p.set("venue", filters.venue); }
    if (filters.free == '1') { p.set("free", '1'); }
    if (filters.latitude && filters.longitude) {
        p.set("lat", "46.81389902358164");
        p.set("long", "-71.21664211898582");
    }
    p.set("pagination", "1");
    p.set("limit", "60");
    return p;

};

export function useEvents(filters: Filters, options?: { maxAgeMs?: number; enabled?: boolean }) {
    const params = buildQueryParams(filters);
    return usePaginatedEvents(`/api/events?${params}`, {
        ...options, enabled: options?.enabled !== false && Boolean(params.get('date')),
    });
}
